import React from "react";

import { Company, CompanySelection } from "../types/crm";

const NEW_OPTION = "__new__";

interface CompanyPickerProps {
  companies: Company[];
  value: CompanySelection;
  onChange: (value: CompanySelection) => void;
}

export function CompanyPicker({ companies, value, onChange }: CompanyPickerProps) {
  const selectValue = value.type === "existing" ? String(value.id) : NEW_OPTION;

  return (
    <div>
      <label htmlFor="company" className="block text-sm font-medium text-slate-700">
        Empresa
      </label>
      <select
        id="company"
        value={selectValue}
        onChange={(event) => {
          const raw = event.target.value;
          if (raw === NEW_OPTION) {
            onChange({ type: "new", data: { name: "", cnpj: "", website: "" } });
          } else {
            onChange({ type: "existing", id: Number(raw) });
          }
        }}
        className="mt-1 block w-full rounded-[10px] border border-border-subtle px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
      >
        <option value="" disabled>
          Selecione uma empresa
        </option>
        {companies.map((company) => (
          <option key={company.id} value={company.id}>
            {company.name}
          </option>
        ))}
        <option value={NEW_OPTION}>+ Cadastrar nova empresa</option>
      </select>

      {value.type === "new" && (
        <div className="mt-2 space-y-2 rounded-[10px] border border-border-subtle bg-surface p-3">
          <label htmlFor="company_name" className="sr-only">
            Nome da empresa
          </label>
          <input
            id="company_name"
            type="text"
            placeholder="Nome da empresa"
            value={value.data.name}
            onChange={(event) =>
              onChange({ type: "new", data: { ...value.data, name: event.target.value } })
            }
            className="block w-full rounded-[10px] border border-border-subtle px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
          />
          <label htmlFor="company_cnpj" className="sr-only">
            CNPJ
          </label>
          <input
            id="company_cnpj"
            type="text"
            placeholder="CNPJ (opcional)"
            value={value.data.cnpj}
            onChange={(event) =>
              onChange({ type: "new", data: { ...value.data, cnpj: event.target.value } })
            }
            className="block w-full rounded-[10px] border border-border-subtle px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
          />
          <label htmlFor="company_website" className="sr-only">
            Website
          </label>
          <input
            id="company_website"
            type="text"
            placeholder="Website (opcional)"
            value={value.data.website}
            onChange={(event) =>
              onChange({ type: "new", data: { ...value.data, website: event.target.value } })
            }
            className="block w-full rounded-[10px] border border-border-subtle px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
          />
        </div>
      )}
    </div>
  );
}
